import { render, staticRenderFns } from "./AcoesGridDemonstracao.vue?vue&type=template&id=83d711ee&"
import script from "./AcoesGridDemonstracao.vue?vue&type=script&lang=ts&"
export * from "./AcoesGridDemonstracao.vue?vue&type=script&lang=ts&"
import style0 from "./AcoesGridDemonstracao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports